import React from 'react';

import { MenuItem } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import type { ColorSelectFunction } from './ColorSelectComponent';
import { TRANSPARENT_HSLA } from './ColorSelectComponent';
import { InvertColorsOffIcon } from '../icons/InvertColorsOffIcon';

const useStyles = makeStyles()(theme => ({
  row: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing(1),
    paddingLeft: 0,
  },
  text: {
    fontFamily: 'Open Sans',
    fontSize: 14,
    marginLeft: theme.spacing(1),
    marginTop: 3,
  },
}));

interface TransparentOptionProps {
  selectColor: ColorSelectFunction;
}

export function TransparentOption({ selectColor }: TransparentOptionProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <MenuItem
      key={TRANSPARENT_HSLA}
      className={classes.row}
      onClick={(event: React.MouseEvent): void => selectColor(event, null)}
    >
      <InvertColorsOffIcon />
      <span className={classes.text}>Transparent</span>
    </MenuItem>
  );
}
